<template>
  <div>
    <template v-if="!isSpeakerFormEnabled">
      <div class="speaker-list">
        <div class="speaker-list-item" v-for="s in speakers" :key="s._id">
          <div class="speaker-img">
            <img :src="s.imgPath" />
          </div>
          <div class="speaker-info-wrapper">
            <div class="speaker-name">{{s.name}}</div>
            <div class="speaker-title">{{s.title}}</div>
            <div class="speaker-actions">
              <Button class="speaker-delete-btn" icon="ios-trash" shape="circle"></Button>
            </div>
          </div>
        </div>
        <Button class type="primary" @click="enableSpeakerForm()">Add New Speaker</Button>
      </div>
    </template>
    <template v-if="isSpeakerFormEnabled">
      <div class="speaker-form">
        <Form :model="speakerFormData">
          <FormItem label="Image">
            <Upload
              :action="uploadServer"
              :on-success="handleUpload"
              :format="['jpg','jpeg','png']"
              :max-size="3000"
            >
              <Button icon="ios-cloud-upload-outline">Upload</Button>
            </Upload>
          </FormItem>
          <FormItem label="Name">
            <Input v-model="speakerFormData.name" />
          </FormItem>
          <FormItem label="Title">
            <Input v-model="speakerFormData.title" />
          </FormItem>
          <Button type="primary" @click="saveSpeaker()">Save</Button>
          <Button>Cancel</Button>
        </Form>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import $config from "@/config";

export default {
  name: "Speakers",
  data() {
    return {
      form: {},
      speakerFormData: {},
      isSpeakerFormEnabled: false,
      speakerImageUrl: null
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("speakers", {
      findSpeakersInStore: "find"
    }),
    uploadServer() {
      return $config.uploadServer;
    },
    speakers() {
      console.log(
        this.findSpeakersInStore({ webcastId: this.webcast._id }).data
      );
      return this.findSpeakersInStore({ webcastId: this.webcast._id }).data;
    }
  },
  methods: {
    ...mapActions("speakers", {
      findSpeakerAction: "find",
      updateSpeakerAction: "update",
      createSpeakerAction: "create",
      removeSpeakerAction: "remove"
    }),
    enableSpeakerForm() {
      this.isSpeakerFormEnabled = true;
    },
    handleUpload(res, file) {
      console.log(res);
      console.log(file);
      this.$set(this.$data, "speakerImageUrl", res);
    },
    saveSpeaker() {
      const payload = {
        webcastId: this.webcast._id,
        imgPath: this.speakerImageUrl,
        name: this.speakerFormData.name,
        title: this.speakerFormData.title
      };
      this.createSpeakerAction(payload).then(speaker => {
        this.$Message.success("Speaker has been saved");
        this.isSpeakerFormEnabled = false;
      });
    }
  },
  created() {
    this.findSpeakerAction({ query: { webcastId: this.webcast._id } });
  }
};
</script>

<style lang="less">
.speaker-list {
  margin-bottom: 24px;
}
.speaker-list-item {
  height: 84px;
  margin-bottom: 12px;
}
.speaker-img {
  float: left;
  margin-right: 12px;
  img {
    width: 72px;
    height: 72px;
    border-radius: 48px;
  }
}
.speaker-info-wrapper {
  padding-left: 84px;
  padding-top: 14px;
}
.speaker-name {
  font-size: 14px;
}
.speaker-actions {
  float: right;
  top: -32px;
  position: relative;
}
</style>
